// Intent-time preload seam for chat-side modules. Fire-and-forget; once per page load.
import { importSmartCreationWrapper } from './ui/smart-creation-wrapper/import-smart-creation-wrapper';

let hasPreloadedChatOnIntent = false;

function preloadSmartCreationWrapper(): void {
	void importSmartCreationWrapper().catch(() => {});
}

export function preloadChatOnIntent(): void {
	if (typeof window === 'undefined') {
		return;
	}

	if (hasPreloadedChatOnIntent) {
		return;
	}

	hasPreloadedChatOnIntent = true;

	preloadSmartCreationWrapper();
}
